import type { FaireProductEntity } from "../../entity_types/product";

export const p_y9ypg6zg8a: FaireProductEntity = {
  token: "p_y9ypg6zg8a",
  type: "product",
  name: "Blue Apatite Towers",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/911dad7b895eb4fe4c1fd7a2d943e5dfa9cf1083882d1fda7b8113ef33a36ec7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/936d06a6baeaf3146ea707a404149b6474b275c6c67ba8e66ded1cb33a50aad7.jpeg"
  ],
  priceDollars: 9.01,
  description: "Pick Your Own\n\nFeeling stuck in a rut? Let Blue Apatite be your guide to a more empowered, inspired life. This remarkable gemstone is a powerful ally in boosting confidence, motivation, and creativity.\n\n * Enhances self-esteem and inner strength \n * Increases drive and determination \n * Promotes open-mindedness and adaptability \n * Supports the healing of bone and cartilage \nBlue Apatite is a transformative crystal that helps you break free from self-limiting beliefs and step into your fullest potential. As you work with this stone, you'll notice a surge of courage and clarity, empowering you to take bold action towards your goals.\n\nWhether you're tackling a creative project, chasing a big dream, or simply wanting to feel more self-assured in your daily life, Blue Apatite will be your steadfast companion. Its energizing influence will help you cultivate a more positive self-image, unleash your innovative ideas, and approach life with an open and adaptable mindset.\n",
  tags: [],
  msrpDollars: 18.01,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:56.809Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
